import { HomeExportOutlineIcon } from './HomeExportOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 6D0FFE6B-65D9-4D72-9743-C2537F3E6307
 * name home-export-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-export-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseExportOutlineIcon = HomeExportOutlineIcon;
export default HouseExportOutlineIcon